module.exports = __webpack_public_path__ + "static/media/companynewsImg7.4426eb8a.jpg";